import { VEHICLE_REGISTRATION_METHOD } from "@shared/constants";
import { useIsKeyAccount } from "@redux/reducers/auth";
import { useGetJourneySpecificConfig } from "@hooks/useGetJourneySpecificConfig";
import { computeAvailableRegistrationMethods } from "@lib/computeAvailableRegistrationMethods";

export const useCanCitroenHandleRegistrationPostalCode = () => {
  const journeyConfig = useGetJourneySpecificConfig();
  const isKeyAccount = useIsKeyAccount();

  return postalCode => {
    const methods = computeAvailableRegistrationMethods(
      journeyConfig?.vehicleRegistration,
      postalCode,
      { isKeyAccount }
    );
    return methods.some(m => m.method === VEHICLE_REGISTRATION_METHOD.CITROEN);
  };
};
